export interface NumberSelectorOptions {
    min?: number;
    max?: number;
    selected?: number;
    labelMin?: string;
    labelMax?: string;
    title?: string;
}

export class NumberSelector {
    private options: Required<NumberSelectorOptions>;
    private selectedValue: number;
    private container: HTMLElement;

    constructor(container: HTMLElement, options: NumberSelectorOptions = {}) {
        this.options = {
            min: options.min ?? 1,
            max: options.max ?? 10,
            selected: options.selected ?? 0,
            labelMin: options.labelMin ?? 'Zeer slecht',
            labelMax: options.labelMax ?? 'Uitzonderlijk',
            title: options.title ?? '',
        };
        this.selectedValue = this.options.selected;
        this.container = container;
        this.render();
    }

    private render(): void {
        this.container.innerHTML = '';

        if (this.options.title) {
            const titleDiv = document.createElement('div');
            titleDiv.className = 'number-selector-row__label';
            titleDiv.textContent = this.options.title;
            this.container.appendChild(titleDiv);
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'number-selector-wrapper';

        const selectorDiv = document.createElement('div');
        selectorDiv.className = 'number-selector';

        for (let i = this.options.min; i <= this.options.max; i++) {
            const item = document.createElement('span');
            item.className =
                'number-selector__item' +
                (i === this.selectedValue
                    ? ' number-selector__item--active'
                    : '');
            item.textContent = String(i);
            item.addEventListener('click', () => {
                this.selectedValue = i;
                this.render();
            });
            selectorDiv.appendChild(item);
        }

        wrapper.appendChild(selectorDiv);

        const labelsDiv = document.createElement('div');
        labelsDiv.className = 'number-selector__labels';
        labelsDiv.innerHTML = `<span>${this.options.labelMin}</span><span>${this.options.labelMax}</span>`;
        wrapper.appendChild(labelsDiv);

        this.container.appendChild(wrapper);
    }

    public getValue(): number {
        return this.selectedValue;
    }

    public setValue(value: number): void {
        this.selectedValue = value;
        this.render();
    }
}
